import React from 'react';
import TagChip from '../tagchip';


export default (props) => {

    const { items = [], getColor, closable, ...rest } = props

    return (
        <div { ...rest }>
            {items?.map(item => {
                const color = typeof getColor === 'function' && getColor(item)
                return (
                    <TagChip
                        color={color}
                        key={item.value}
                        closable={closable} 
                        className="tag-items"
                        >
                        {item.label}
                    </TagChip>
                )
            })}
        </div>
    )

}